/* Su mobile ricollega le frecce del carosello Trustpilot (che nel widget
   originale cambiano "pagina" da 3 card) a uno scorrimento di UNA card
   per volta, coerente con il layout a scorrimento orizzontale definito in
   assets/custom-spacing-fix.css. Scroll istantaneo (non 'smooth') per
   affidabilita'. */
(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function scrollByCard(container, direction) {
    var card = container.querySelector('.tp-review-card');
    if (!card) return;
    var style = getComputedStyle(container);
    var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    var amount = card.getBoundingClientRect().width + gap;
    var maxScroll = container.scrollWidth - container.clientWidth;
    var target = container.scrollLeft + direction * amount;
    target = Math.max(0, Math.min(maxScroll, target));
    container.scrollTo({ left: target, behavior: 'instant' });
  }

  document.addEventListener('click', function (e) {
    if (!isMobile()) return;
    var prevBtn = e.target.closest('.tp-reviews-arrow--prev');
    var nextBtn = e.target.closest('.tp-reviews-arrow--next');
    if (!prevBtn && !nextBtn) return;
    var viewport = (prevBtn || nextBtn).closest('.tp-reviews-viewport');
    if (!viewport) return;
    var pagesEl = viewport.querySelector('.tp-reviews-pages');
    if (!pagesEl) return;
    scrollByCard(pagesEl, prevBtn ? -1 : 1);
  });
})();
